module.exports = __webpack_public_path__ + "static/media/night_flight_sample_8.864800fe.jpg";